"use client";

import { c as _c } from "react/compiler-runtime";
import { Image, Link } from "@opensea/next-ui-kit";
import { Card, classNames, Flex, FlexColumn, Markdown, TextBody, TextOverflow } from "@opensea/ui-kit";
import { ChevronRight } from "@opensea/ui-kit/icons";
import { useContext, useState } from "react";
import { OverviewModuleCarouselContext } from "@/components/collection/overview/components/OverviewModuleCarousel";
import { getValidUrl } from "@/lib/helpers/url";
export function ContentBlockCard(t0) {
  const $ = _c(21);
  const {
    className,
    title,
    description,
    media,
    externalUrl
  } = t0;
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const {
    contentHeight
  } = useContext(OverviewModuleCarouselContext);
  const t1 = isDescriptionOpen ? undefined : contentHeight;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      height: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== media) {
    t3 = media?.imageUrl ? <Image alt="" layout="fill" objectFit="cover" sizes="auto" src={media.imageUrl} /> : null;
    $[2] = media;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Flex className="relative aspect-16/9 w-full bg-bg-additional-2">{t3}</Flex>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== title) {
    t5 = <TextBody size="md" weight="semibold">{title}</TextBody>;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== description) {
    t6 = description?.trim() ? <TextOverflow className="mt-1 lg:mt-2" lines={3} onOpenChange={open => setIsDescriptionOpen(open)}><Markdown>{description}</Markdown></TextOverflow> : null;
    $[8] = description;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== externalUrl) {
    t7 = externalUrl ? <Link className="mt-auto hover:opacity-70 active:opacity-60" href={getValidUrl(externalUrl.href)} rel="noopener noreferrer" target="_blank" variant="unstyled"><Flex className={classNames("items-center", "pt-4 lg:pt-6")}><TextBody weight="semibold">{externalUrl.label ?? "Visit link"}</TextBody><ChevronRight size={21} /></Flex></Link> : null;
    $[10] = externalUrl;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <FlexColumn className="flex-1 p-4 lg:p-6">{t5}{t6}{t7}</FlexColumn>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== className || $[17] !== t2 || $[18] !== t4 || $[19] !== t8) {
    t9 = <Card className={className} style={t2}>{t4}{t8}</Card>;
    $[16] = className;
    $[17] = t2;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}